// src/pages/Account.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAccessibility } from '../contexts/AccessibilityContext';
import AacButton from '../components/aac/AacButton';
import './Account.css';
import { useFocusableNavigation } from '../hooks/useFocusableNavigation';

const Account = () => {
  const { user, signOut } = useAuth();
  const { announce } = useAccessibility();
  useFocusableNavigation();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    announce('Logged out successfully');
    navigate('/login', { replace: true });
  };

  return (
    <div className="auth-page">
      <h1>My Account</h1>
      <p className="auth-page__intro">Logged in as {user?.email}</p>

      <div className="auth-page__actions">
        <AacButton shortcut={1} onClick={handleSignOut} variant="secondary">
          Sign Out
        </AacButton>
      </div>
    </div>
  );
};

export default Account;
